import { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import Header from './Header';
import HomeRedirect from 'app/components/HomeRedirect';

import {
  requestPasswordReset
} from 'shared/services/user';

import {
  login as loginPath
} from 'app/routes';

// there is also PORTAL_ORIGIN (0) and PWA_ORIGIN (1).
// PORTAL_ORIGIN will redirect to the old portal
const PORTAL2_ORIGIN = 2;

const PasswordReset = props => {
  const {
  } = props;

  const [state, setState] = useState({
    submitting: false,
    error: null,
    emailError: false,
    passwordRequested: false
  });

  const emailRef = useRef('');

  const user = useSelector(state => state.userReducer.user);
  const dispatch = useDispatch();
  const history = useHistory();

  const onEmailChange = event => {
    emailRef.current = event.target.value
  }

  const parsePhone = value => {
    let phone = null;

    if (!value.match(/[^\d\+\ \-]/)) {
      phone = value;
    }

    return phone;
  }

  const onSubmit = async event => {
    event.preventDefault();

    let email = null;
    if (emailRef.current.match(/@/)) {
      email = emailRef.current;
    }

    let phone = null;
    if (!email) {
      phone = parsePhone(emailRef.current);
    }

    if (!email && !phone) {
      let error = 'Please enter a valid email address or phone number.';

      setState(state => ({
        ...state,
        error,
        emailError: true
      }));

      return;
    }

    setState(state => ({
      ...state,
      submitting: true
    }));

    let params = {
      origin: PORTAL2_ORIGIN,
      email: phone || email
    };

    try {
      let resp = await requestPasswordReset(params);

      setState(state => ({
        ...state,
        submitting: false,
        passwordRequested: true,
        error: null,
        emailError: false
      }));
    } catch (err) {
      setState(state => ({
        ...state,
        submitting: false,
        error: err.error || err,
        emailError: false,
      }));
    }
  }

  if (user) {
    return <HomeRedirect />;
  }

  let view;
  if (state.passwordRequested) {
    view = (
      <div>
        <p style={{ margin: '2rem 0 1rem' }}>A password reset link has been sent to your email address.</p>
        <Button className="bs-btn bs-btn-default full-width" type="button" onClick={() => history.push(loginPath)}>
          <span>Back to Login</span>
        </Button>
      </div>
    )
  } else {
    view = (
      <div>
        <p>Enter you email address or phone number to reset your password.</p>
        {state.error && <p className="error">{state.error}</p>}
        <Form.Group>
          <Form.Label htmlFor="email">Email or phone</Form.Label>
          <Form.Control className={state.emailError ? 'error' : ''}
            type="text"
            name="email"
            placeholder="Email address or phone number"
            onChange={onEmailChange}
          />
        </Form.Group>
        <Button variant="primary" className="bs-btn bs-btn-primary full-width" type="submit">
          <span>{state.submitting ? 'Requesting link...' : 'Request Link'}</span>
        </Button>
        <Button className="bs-btn bs-btn-default full-width" type="button" onClick={() => history.push(loginPath)}>
          <span>Back to Login</span>
        </Button>
      </div>
    )
  }

  return (
    <Form className="login-form" onSubmit={onSubmit}>
      <Header />
      <h2>Password Reset</h2>
      {view}
    </Form>
  )
}

export default PasswordReset;
